import axios from 'axios';

const runtimeConfig = window.__APP_CONFIG__ || {};
const BACKEND_URL =
  runtimeConfig.REACT_APP_ATTRITION_SERVICE_API_URL ||
  process.env.REACT_APP_ATTRITION_SERVICE_API_URL;

if (!BACKEND_URL) {
  console.warn(
    'Missing API base URL. Set REACT_APP_ATTRITION_SERVICE_API_URL in runtime config or frontend build env.'
  );
}

const API_BASE = BACKEND_URL ? `${BACKEND_URL.replace(/\/$/, '')}/api` : '/api';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 second timeout
});

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const calculationAPI = {
  /**
   * Calculate employee attrition cost (DEPRECATED - use leadCalculationAPI.submitLeadAndCalculation)
   * @param {Object} data - Calculation input data
   */
  calculate: async (data) => {
    const payload = {
      annual_salary: data.annualSalary,
      position: data.position,
      job_role: data.jobRole,
      industry: data.industry,
    };
    
    const response = await apiClient.post('/calculations', payload);
    return response.data;
  },

  /**
   * Get calculation history
   * @param {number} limit - Maximum number of calculations to retrieve
   */
  getHistory: async (limit = 50) => {
    const response = await apiClient.get(`/calculations?limit=${limit}`);
    return response.data;
  },

  /**
   * Get a specific calculation by ID
   * @param {string} calculationId - Calculation ID
   */
  getCalculation: async (calculationId) => {
    const response = await apiClient.get(`/calculations/${calculationId}`);
    return response.data;
  },

  /**
   * Get reference data for form dropdowns
   */
  getReferenceData: async () => {
    const response = await apiClient.get('/reference-data');
    return response.data;
  },

  /**
   * Delete a calculation
   * @param {string} calculationId - Calculation ID
   */
  deleteCalculation: async (calculationId) => {
    const response = await apiClient.delete(`/calculations/${calculationId}`);
    return response.data;
  },
};

export const leadCalculationAPI = {
  /**
   * Submit lead information and get calculation results - MAIN LEAD MAGNET ENDPOINT
   * @param {Object} leadData - Lead information
   * @param {string} leadData.name - Contact name
   * @param {string} leadData.email - Contact email
   * @param {string} leadData.company_name - Company name
   * @param {string} leadData.company_headcount - Company size range
   * @param {Object} calculationData - Calculation input data
   * @param {number} calculationData.annualSalary - Annual salary
   * @param {string} calculationData.position - Position level
   * @param {string} calculationData.jobRole - Job role
   * @param {string} calculationData.industry - Industry
   */
  submitLeadAndCalculation: async (leadData, calculationData) => {
    const payload = {
      lead_data: {
        name: leadData.name,
        email: leadData.email,
        company_name: leadData.company_name,
        company_headcount: leadData.company_headcount,
      },
      calculation_data: {
        annual_salary: calculationData.annualSalary,
        position: calculationData.position,
        job_role: calculationData.jobRole,
        industry: calculationData.industry,
      }
    };
    
    const response = await apiClient.post('/lead-calculation', payload);
    return response.data;
  },

  /**
   * Get all leads (admin function)
   */
  getLeads: async (limit = 100) => {
    const response = await apiClient.get(`/leads?limit=${limit}`);
    return response.data;
  },

  /**
   * Get lead statistics
   */
  getLeadStats: async () => {
    const response = await apiClient.get('/lead-stats');
    return response.data;
  },
};

export default calculationAPI;
